import Parse from "parse";

export const getRanking = async (playerKeyCode) => {
  const query = new Parse.Query(Parse.Object.extend("silence1"));

  query.exists("score");
  query.exists("clearTime");

  query.limit(1000);

  const users = await query.find();

  // 개인 데이터 매핑
  const mapped = users.map((u) => ({
    keyCode: u.get("keyCode"),
    playerName: u.get("playerName") || "",
    score: u.get("score") || 0,
    clearTime: u.get("clearTime") || 0,
    introInCode: u.get("introInCode") || null,
    total: u.get("score") || 0,
  }));

  // 개인 랭킹 정렬
  // 조건1. total 높은순
  // 조건2. clearTime 낮은순
  const ranking = mapped.sort((a, b) => {
    if (b.total !== a.total) return b.total - a.total;
    return a.clearTime - b.clearTime;
  });

  // 내 랭킹
  const myRank = ranking.findIndex((u) => u.keyCode === playerKeyCode) + 1;

  return {
    sorted: ranking,
    myRank,
  };
};
